import axios from '../utils/axios';

export default function postCompetitionBulkAction(adminId, data) {
    
    return (
        axios.post('/admin/'+adminId + '/competition/v2/competition/admin/bulkactionbyscore', data)
    )
}
